import React from "react"
import styled from "styled-components"

const SectionIllustrationWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  z-index: ${props => props.zIndex};
  left: ${props => props.position};
  transform: ${props => props.transform};
  margin: 0 auto;
  width: ${props => (props.bigIllustration ? "70%" : "50%")};

  @media (max-width: 1100px) {
  }

  @media (max-width: 900px) {
    width: 60%;
  }

  @media (max-width: 768px) {
    width: ${props => (props.isChat ? "80%" : "100%")};
  }

  @media screen and (max-width: 420px) {
    width: 100%;
  }
`

const SectionIllustration = props => (
  <SectionIllustrationWrapper
    bigIllustration={props.bigIllustration}
    transform={props.transform}
    position={props.position}
    zIndex={props.zIndex}>
    <img src={props.name} />
  </SectionIllustrationWrapper>
)

export default ({ name, position, transform, bigIllustration, zIndex }) => (
  <SectionIllustration
    bigIllustration={bigIllustration}
    name={name}
    transform={transform}
    position={position}
    zIndex={zIndex}
  />
)



// WEBPACK FOOTER //
// ./src/components/SectionIllustration.js